<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.75 1.75a.75.75 0 00-1.5 0v2a.75.75 0 001.5 0v-2zm4.2 2.36a.75.75 0 10-1.06-1.06l-1.415 1.414a.75.75 0 101.06 1.061l1.415-1.414zM15 8a.75.75 0 01-.75.75h-2a.75.75 0 010-1.5h2A.75.75 0 0115 8zm-3.111 4.95a.75.75 0 001.06-1.06l-1.413-1.415a.75.75 0 00-1.061 1.06l1.414 1.415zM7.999 15a.75.75 0 01-.75-.75v-2a.75.75 0 011.5 0v2A.75.75 0 018 15zM3.05 11.89a.75.75 0 001.06 1.06l1.415-1.414a.75.75 0 00-1.06-1.061L3.05 11.889zM1 8a.75.75 0 01.75-.75h2a.75.75 0 010 1.5h-2A.75.75 0 011 8zm3.11-4.95a.75.75 0 10-1.06 1.06l1.414 1.415a.75.75 0 001.061-1.06L4.111 3.05z"
    fill="currentColor"
  />
</svg>
